import { render } from "./RegisterModal.vue?vue&type=template&id=aa799ace&scoped=true"
import script from "./RegisterModal.vue?vue&type=script&lang=js"
export * from "./RegisterModal.vue?vue&type=script&lang=js"

import "./RegisterModal.vue?vue&type=style&index=0&id=aa799ace&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa799ace"]])

export default __exports__